import React, { Component } from "react";
import PropTypes from "prop-types";
import { conformToMask } from "react-text-mask";

export default class TextToMask extends Component {
  static masksTree = {
    phone: [
      "(",
      /\d/,
      /\d/,
      ")",
      " ",
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/
    ],
    cnpj: [
      /\d/,
      /\d/,
      ".",
      /\d/,
      /\d/,
      /\d/,
      ".",
      /\d/,
      /\d/,
      /\d/,
      "/",
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/
    ]
  };

  static propTypes = {
    value: PropTypes.string,
    mask: PropTypes.string,
    customMask: PropTypes.array
  };

  static defaultProps = {
    value: "",
    mask: undefined,
    customMask: []
  };

  content() {
    const mask = this.props.mask
      ? TextToMask.masksTree[this.props.mask]
      : this.props.customMask;
    const content = conformToMask(this.props.value || "", mask, {
      guide: false
    }).conformedValue;
    return <p>{content || "-"}</p>;
  }

  render() {
    return <div>{this.content()}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/support/text-to-mask/index.jsx